import { debounce } from 'throttle-debounce';
/**
 * キャラクターを内包しているフレームの高さを調整する
 */
export const charaFrame = (containerEl) => {
    if (!containerEl) {
        return;
    }
    // Swiperのコンテナ要素を取得
    const carouselEl = containerEl.querySelector('.swiper-container');
    if (!carouselEl) {
        return;
    }
    // フレームサイズの調整
    updateContainerHeight(containerEl, carouselEl);
    window.addEventListener('resize', debounce(200, () => {
        updateContainerHeight(containerEl, carouselEl);
    }));
};
const updateContainerHeight = (containerEl, carouselEl) => {
    const height = carouselEl.offsetHeight * 0.9;
    containerEl.style.height = `${height}px`;
};
